import VMultiSelectComponent from "./VMultiselect.vue";

frappe.provide("frappe.ui");

export default class VMultiSelect {
  constructor({
    wrapper,
    onSelect,
    options,
    placeholder,
    searchable,
    currentValue,
    canDeselect,
    disabled,
    closeOnSelect,
    // Custom HTML to display when no result is found in search
    noResultHTML = "",
    // When working with Objects as options.
    trackBy,
    label,
    multiple = true, // default to true
    // allowMultiselect, onRemove
  } = {}) {
    this.options = options;
    this.$multiselect = new Vue({
      el: wrapper,
      render: h =>
        h(VMultiSelectComponent, {
          props: {
            options,
            currentValue,
            onSelect,
            canDeselect,
            placeholder,
            searchable,
            trackBy,
            label,
            disabled,
            closeOnSelect,
            noResultHTML,
            multiple,
          },
        }),
    });

    [this.multiselect] = this.$multiselect.$children;
  }
}

frappe.ui.VMultiSelect = VMultiSelect;

/**
 * Add wrapper to find relevant elements in the HTML and initialize the
 * selector automatically without any need to manually setup selector.
 */
frappe.ready(() => {
  function camelCaseObjectKeys(obj) {
    return Object.keys(obj).reduce((acc, current) => {
      acc[$.camelCase(current)] = obj[current];
      return acc;
    }, {});
  }
  const SELECTORS = {
    V_SELECT: "v-select",
  };

  function initializeSelector({
    selector,
    options,
    currentValue,
    searchable,
    allowEmpty,
    label,
    onSelect,
    trackBy,
    placeholder = "",
    noResultHTML = "",
    disabled,
    closeOnSelect,
  }) {
    return new VMultiSelect({
      wrapper: selector,
      options,
      currentValue,
      searchable,
      canDeselect: allowEmpty,
      label,
      trackBy,
      placeholder,
      onSelect,
      disabled,
      closeOnSelect,
      noResultHTML,
    });
  }

  let selectors = $(`.${SELECTORS.V_SELECT}`);
  if (!selectors) return;

  selectors = Array.from(selectors);
  selectors.forEach(selector => {
    const vSelectElem = $(selector);

    const selectorIdString = vSelectElem.data("select-id");
    const optionsDlSelector = vSelectElem.data("select-options-data-list");
    const label = vSelectElem.data("select-label");
    const trackBy = vSelectElem.data("select-track-by");
    const searchable = vSelectElem.data("select-searchable");
    const allowEmpty = vSelectElem.data("select-allow-empty");
    const placeholder = vSelectElem.data("select-placeholder") || "";
    const selectCallback = vSelectElem.data("select-callback");
    const closeOnSelect = vSelectElem.data("select-close-on-select");
    const noResultHTML =
      (vSelectElem.find("div.select-no-result-html") &&
        vSelectElem.find("div.select-no-result-html").html()) ||
      "";
    const disabled = vSelectElem.data("select-disabled") || false;
    const dataListSelector = `datalist[data-select-id="${optionsDlSelector}"]`;
    const selectorDataListElem = $(dataListSelector);

    // eslint-disable-next-line no-unused-vars
    const currentValueId = selectorDataListElem.data("select-current-value");

    const optionsElems = $(`${dataListSelector} option`);
    const selectedOptions = optionsElems.filter("[selected]");
    const options = Array.from(
      optionsElems.map((_, opt) => camelCaseObjectKeys($(opt).data())),
    );
    const optionsSelected = Array.from(
      selectedOptions.map((_, opt) => camelCaseObjectKeys($(opt).data())),
    );
    let currentValue;

    // eslint-disable-next-line prefer-const
    currentValue = optionsSelected;

    function handleSelect(value) {
      const selectedValue = trackBy ? value[trackBy] : value;
      // Changing `data` attr through `data` call does not apply the change to
      // DOM so we have to do it using `attr` call.
      $(selectorDataListElem).attr("data-select-current-value", selectedValue);
      $(selectorDataListElem).data("select-current-value", selectedValue);

      if (selectCallback && window[selectCallback]) {
        window[selectCallback](selectedValue);
      }
    }

    initializeSelector({
      selector: `.${SELECTORS.V_SELECT}[data-select-id="${selectorIdString}"]`,
      options,
      currentValue,
      searchable,
      allowEmpty,
      label,
      trackBy,
      placeholder,
      onSelect: handleSelect,
      disabled,
      closeOnSelect,
      noResultHTML,
    });
  });
});
